import i18n from 'es2015-i18n-tag';
import { Field, Formik, FormikHelpers } from 'formik';
import * as yup from 'yup';
import Input from '../../../../common/ui-components/input/input.component';
import { TeamAdvisor, TeamModel } from '../../models/team-model';
import FetchTeam from '../../resolver/fetch-team.component';
import { updateTeam } from '../../team-service';
import EditTeam from './edit-team.component';
import { useNavigate } from 'react-router';

interface EditSportTeamFormValue {
    name: string;
    sport: string;
    league: string;
    advisor?: TeamAdvisor;
}

const formSchema = yup.object().shape({
    name: yup.string().trim().required(),
    sport: yup.string().trim().required(),
    league: yup.string().trim().required(),
    advisor: yup.object().nullable()
});

interface EditSportTeamProps {
    team: TeamModel;
}

type EditSportTeam = EditSportTeamProps;

const EditSportTeam = (props: EditSportTeam) => {
    const navigate = useNavigate();

    const onSave = (
        formValue: EditSportTeamFormValue,
        { setSubmitting }: FormikHelpers<EditSportTeamFormValue>
    ) => {
        const { id } = props.team;
        const { name, sport, league, advisor } = formValue;
        updateTeam({
            id,
            name,
            league,
            sport,
            advisor,
            isBusiness: false,
            members: props.team.members,
            accountId: props.team.accountId
        })
            .then(() => navigate(-1))
            .finally(() => setSubmitting(false));
    };

    return (
        <Formik
            initialValues={{
                name: props.team.name,
                sport: props.team.sport,
                league: props.team.league,
                advisor: props.team.advisor
            }}
            validationSchema={formSchema}
            onSubmit={onSave}
        >
            {formikProps => (
                <EditTeam advisorLabel={i18n`Betreuer`} {...props} {...formikProps}>
                    <Field
                        component={Input}
                        title={i18n`Sportart`}
                        name="sport"
                        className="edit-team__form-field"
                        required
                    />
                    <Field
                        component={Input}
                        title={i18n`Ligazugehörigkeit`}
                        name="league"
                        className="edit-team__form-field"
                        required
                    />
                </EditTeam>
            )}
        </Formik>
    );
};

const Editor = EditSportTeam;

export default () => <FetchTeam>{team => <Editor team={team} />}</FetchTeam>;
